var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "none"
    },
    id: "svg6",
    viewBox: "0 0 27.169539 23.29542",
    height: 23.29542,
    width: 27.169538,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#1dc071",
      strokeWidth: 2
    },
    id: "path2",
    d: "m 9.1694915,6.2928466 v -1.09413 c 0,-2.12024 0,-3.18036 0.67965,-3.77772 0.6796605,-0.59736999 1.7310105,-0.46130999 3.8337205,-0.1892 l 7.256629,0.9391 c 2.4911,0.32238 3.7367,0.48357 4.4833,1.33308 0.7467,0.84951 0.7467,2.10544 0.7467,4.6173 v 7.0528404 c 0,2.5119 0,3.7678 -0.7467,4.6173 -0.7466,0.8496 -1.9922,1.0107 -4.4833,1.3331 l -7.256629,0.9391 c -2.10271,0.2721 -3.15406,0.4082 -3.8337205,-0.1892 -0.67965,-0.5973 -0.67965,-1.6575 -0.67965,-3.7777 v -0.8764"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1dc071"
    },
    id: "path4",
    d: "m 1.2335,11.240937 -0.8107,-0.5855 -0.4228,0.5855 0.4228,0.5855 z m 13.999999,1 c 0.552285,0 1,-0.4477 1,-1 0,-0.5523 -0.447715,-1 -1,-1 z M 4.7562,4.6554469 0.4228,10.655437 l 1.6214,1.171 4.33331,-6.0000101 z m -4.3334,7.1709901 4.3334,6 1.62131,-1.171 -4.33331,-6 z m 0.8107,0.4145 h 13.999999 v -2 H 1.2335 Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.783a8ecf0c5f3820e125ec5ac9540358.svg";
export { ForwardRef as ReactComponent };